import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setStep } from '../features/step/stepSlice';

export default function Card({
  step,
  title,
  children,
  disabled,
  CollapsedContent,
  showStep = true,
  onEdit,
}) {
  const currentStep = useSelector((state) => state.step.step);
  const reviled = useSelector((state) => state.step.reviled);
  const { isError } = useSelector((state) => state.error);
  const dispatch = useDispatch();

  const collapsed = step !== currentStep && !isError;

  const onEditClick = () => {
    if (onEdit) {
      onEdit();
      return;
    }
    dispatch(setStep(step));
  };

  if (reviled.indexOf(step) < 0 && !isError) {
    return null;
  }

  let cardClass = 'card';

  if (collapsed) {
    cardClass += ' collapsed';
  }

  return (
    <div className="card-wrapper">
      <div className={cardClass}>
        <header>
          <CardTitle step={step} showStep={showStep} collapsed={collapsed}>
            {title}
          </CardTitle>

          {collapsed && !disabled && currentStep > step && (
            <div onClick={onEditClick} className="edit pointer">
              Change
            </div>
          )}
        </header>
        {collapsed ? <CollapsedContent /> : <div>{children}</div>}
      </div>
    </div>
  );
}

function CardTitle({ step, showStep, children, collapsed }) {
  let titleClass = 'card-title bolder';
  if (collapsed) {
    titleClass += ' mb-0 pointer collapsed';
  }

  if (!children) {
    return null;
  }

  return (
    <h3 className={titleClass}>
      {step && showStep && <span className="card-number">{step}</span>} {children}
    </h3>
  );
}
